/** Shared legal metadata — keep in sync across policy pages and modals. */
export const LEGAL_ENTITY = 'AstraWeb Miami LLC';
export const PRODUCT_NAME = 'LoyalPass';
export const EFFECTIVE_DATE = 'May 20, 2026';
export const CONTACT_EMAIL = 'loyalpassapp@gmail.com';
export const WEBSITE_URL = 'https://www.loyalpassapp.com';
export const GOVERNING_STATE = 'Florida';
